import React, { useState } from 'react';

import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Link } from '@deliveryhero/pd-cookbook/components/Link';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { buildApiUrl } from 'services/api';
import DrawerActions from 'src/components/DrawerActions';

export const UploadEmployee = (props: {
  handleUpload: (file: File) => void;
  isLoading: boolean;
  config: Configuration | Record<string, never>;
}) => {
  const { handleUpload, isLoading, config } = props;
  const [file, setFile] = useState<File | null>(null);

  const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    if (target.files) {
      setFile(target.files[0]);
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item>
        <Typography type="paragraph-sm">
          Please complete the template with the information below and upload the
          file. You can download the template below.
        </Typography>
        <Typography type="label-md">
          <Link
            href={buildApiUrl(
              '/company-portal/users/upload-template',
              config.api_host
            )}
            rel="download"
          >
            Download template
          </Link>
        </Typography>
      </Grid>
      <Grid item>
        <input
          accept=".csv"
          type="file"
          onChange={handleFileInput}
          data-testid="fileUpload"
        />
      </Grid>
      <Grid item xs={12}>
        <DrawerActions>
          <Button
            size="small"
            layout="full-width-primary"
            status={isLoading ? 'is-loading' : 'is-idle'}
            onClick={() => handleUpload(file as File)} // method only called when File is not null
            disabled={!Boolean(file)}
          >
            Upload
          </Button>
        </DrawerActions>
      </Grid>
    </Grid>
  );
};
